const notes = {
  date: "Date",
  category: "Category",
  type: "Type",
  note: "Note",
}

export default notes;